import { selectApp } from "./selectApp";
import {isKia, KIA_SUCCESS_RETURN_URL} from "../utils/isKia";

export const selectSuccessReturnUrl = state => isKia() ? KIA_SUCCESS_RETURN_URL : selectApp(state).successReturnUrl;
